module.exports = __webpack_public_path__ + "img/unit_sale.521616a8.png";